import { useState, useCallback } from 'react';

export function useToast() {
  const [toast, setToast] = useState<{
    title: string;
    description: string;
  } | null>(null);

  const showToast = useCallback((toastObj: { title: string; description: string }) => {
    setToast(toastObj);
    setTimeout(() => setToast(null), 4000); // Auto-dismiss after 2 seconds
  }, []);

  return { toast, showToast };
} 